

































































































































































































































































































































import {Vue, Component, Watch, Ref, Prop} from 'vue-property-decorator'
import {Getter, Action, Mutation} from "vuex-class";
import {DateTime} from "luxon";
import {cloneDeep, isEqual} from "lodash";
import {CollapseTransition} from "vue2-transitions";
import FieldTooltip from "@/components/FieldTooltip.vue";
import {
  FormRowWings,
  SelectWings,
  DatePickerWings,
  ToggleWings,
  Collapse,
  SpoilerWings,
  TimeoutWings
} from '@/components';
import {SmsTextInputWings} from '@/components/SMS';
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {TemplateItem} from '@/store/templates/types';
import {MsgTransports} from '@/store/types';
import { transformTransport } from '@/utils/download-helper';

@Component({
  components: {
    FieldTooltip,
    FormRowWings,
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    SmsTextInputWings,
    CollapseTransition,
    TimeoutWings,
  },
  methods: {transformTransport}
})
export default class GenericTemplate extends Vue {
  @Ref('validator') validator: any;
  @Prop() transport!: MsgTransports;
  @Prop() distribution!: any;

  @Getter("partners") partnersList: any;
  @Getter("partnerUsers") partnerUsersList: any;
  @Getter("originators") originatorsList: any;
  @Getter("priorityList") priorityList: any;
  @Getter("messageTypes") messageTypesList: any;
  @Getter("blacklists") blacklistsList: any;
  @Getter("transportsMultichannel") transportsMultichannelList: any;
  @Getter("multichannelTemplates") smsMultichannelTemplatesList: any;
  @Getter("moderationSettings") moderationSettings: any;

  @Action("getTemplateItem") actionGetTemplateItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnersUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getBlacklists") actionGetBlackLists: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getTransportsMultichannel") actionGetTransportsMultichannel: any;
  @Action("getMultichannelTemplates") actionGetMultichannelTemplates: any;
  @Action("saveTemplate") actionSaveTemplate: any;
  @Action("deleteTemplate") actionDeleteTemplate: any;
  @Action("createDraft") actionCreateDraft: any;
  @Action("sendToModeration") actionSendToModeration: any;
  @Action("replaceDraft") actionReplaceDraft: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private emailTransport: MsgTransports = MsgTransports.EMAIL;
  private pushTransport: MsgTransports = MsgTransports.PUSH;
  private mnTransport: MsgTransports = MsgTransports.MAILNOTIFY;

  private templateSaved: any
  private weekDays = [
    {value: 'MON'},
    {value: 'TUE'},
    {value: 'WED'},
    {value: 'THU'},
    {value: 'FRI'},
    {value: 'SAT'},
    {value: 'SUN'}
  ];
  private is_cascading = false;
  private isEditable = true

  get moderation() {
    return this.moderationSettings.find((item: any) => item.transportName == this.transport)?.status === 1
  }

  async createDraft() {
    try {
      const resp = await this.actionCreateDraft({templateId: this.template.templateId})
      if (resp?.data?.id) {
        this.$router.push(`/template/${transformTransport(this.transport)}/${resp.data.id}`)
      }
    } catch(error) {
      notifyError(error)
    }
  }

  async sendToModeration() {
    if (this.isTemplateChanged() && await notifyDelete(this.$t('dialog.confirm').toString())) {
      await this.onSaveItem(false);
    }
    try {
      await this.actionSendToModeration({templateId: this.template.templateId})
      this.back()
    } catch(error) {
      notifyError(error)
    }
  }

  async replaceDraft() {
    if (!await notifyDelete(this.$t('template.draft.replace').toString())) return
    try {
      await this.actionReplaceDraft({id: this.template.originalId, prev: this.template.templateId})
    } catch(error) {
      notifyError(error)
    }
  }

  created() {
    try {
      this.actionGetMessageTypes();
      this.actionGetTransportsMultichannel(this.transport);
      if (![this.pushTransport, this.mnTransport].includes(this.transport)) {
        this.actionGetOriginators({transport: this.transport.toString(), status: 'ACCEPTED'});
      }
      this.actionGetBlackLists();
      this.templateSaved = cloneDeep(this.template);
      // if (this.$route.params.id) this.getTemplate(this.$route.params.id)
    } catch(error) {
      notifyError(error)
    }
  }

  async getTemplate(templateId: string) {
    this.is_cascading = false
    try {
      let data: TemplateItem = await this.actionGetTemplateItem({id: templateId, transport: this.transport})
      this.setTemplateObject(Object.assign(this.template, data))
      this.templateSaved = cloneDeep(this.template)
      if (this.template.multichannelTemplateId || this.template.multichannelId) this.is_cascading = true
      this.$emit('onLoadTemplate', this.template)
      this.isEditable = !!this.distribution || !this.moderation
                        || (this.moderation && ['ForEdit', 'Denied'].includes(this.template.status))
    } catch(error) {
      notifyError(error)
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.getTemplate(val)
    }
  }

  back():void{
    this.$router.push(`/template/${transformTransport(this.transport)}`);
  }

  onSaveItem(goBack = true): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        await this.actionSaveTemplate({item: this.template, transport: this.transport})
        this.templateSaved = cloneDeep(this.template);
        resolve()
        if (goBack) this.back();
      } catch (error) {
        reject()
        notifyError(error);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    if (!await notifyDelete()) return
    try {
      await this.actionDeleteTemplate({item: {templateId: this.template.templateId}, transport: this.transport})
      this.templateSaved = this.template;
      this.back();
    } catch (error) {
      notifyError(error);
    }
  }

  get minEndingDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.startingDate) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.startingDate)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.startingDate
  }

  get minEndDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.startDatetime) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.startDatetime)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.startDatetime
  }

  @Watch('template.startDatetime', {immediate: true})
  onChangeStartDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.distribution = false
    }
  }

  @Watch('template.endDatetime', {immediate: true})
  onChangeEndDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.distribution = false
    }
  }

  @Watch('template.multichannelId', {immediate: true})
  async onTemplateChangeMultichannel(val: number, oldVal?: number) {
    if (val) {
      let transport = this.transportsMultichannelList.find((item: any) => item.id == val)?.name ?? '';
      if (transport) {
        try {
          await this.actionGetMultichannelTemplates({
            transport: transport.toLowerCase(),
            filter: {
              status: 'Active'
            }
          });
        } catch(error) {
          notifyError(error);
        }
      }
    }
    if (oldVal && val !== oldVal) {
      this.template.multichannelTemplateId = null;
    }
  }

  @Watch('is_cascading', {immediate: true})
  onChangeIsCascading(val?: boolean) {
    if (!val) {
      this.template.multichannelId = null;
      this.template.multichannelTemplateId = null;
      this.template.timeout = null;
    }
  }

  isTemplateChanged() {
    if (this.transport == this.emailTransport) {
      this.template.message = this.template.message.replace(/\n/ig, '')
      this.templateSaved.message = this.templateSaved.message.replace(/\n/ig, '')
    }
    return !isEqual(this.template, this.templateSaved);
  }

  beforeLeave(to: any, from: any, next: any) {
    notifyConfirm(this.isTemplateChanged(), this.onSaveItem, next);
  }
}
